import React, { Component } from 'react';
import { Col, Row, Card, Modal } from 'antd';
import ProductItem from "components/eCommerce/ProductItem";
import ResponsiveEmbed from "components/eCommerce/ResponsiveEmbed";
import { auth, database } from "../../../firebase/firebase";

class BookGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      urlId: 0,
      series: {},
      books: [],
      isModalVisible: false,
      currentIframe: '',
      modalTitle: ''
    };
    //this.handleChange=this.handleChange.bind(this);
  }

  getBookOrder(book) {
    const data = book.data();
    const explicitOrder = data.order !== undefined
      ? data.order
      : data.book_order !== undefined
        ? data.book_order
        : data.position;
    const explicitOrderNumber = Number(explicitOrder);
    if (!Number.isNaN(explicitOrderNumber) && explicitOrder !== undefined && explicitOrder !== '') {
      return explicitOrderNumber;
    }

    const titleMatch = (data.title || '').match(/\d+/);
    return titleMatch ? Number(titleMatch[0]) : Number.MAX_SAFE_INTEGER;
  }

  sortBooks = (a, b) => {
    const orderDiff = this.getBookOrder(a) - this.getBookOrder(b);
    if (orderDiff !== 0) {
      return orderDiff;
    }

    return (a.data().title || '').localeCompare(b.data().title || '', 'es', { numeric: true });
  }

  handleProductClick = (event, product, id) => {
    if (product.iframe) {
      this.setState({
        currentIframe: product.iframe,
        modalTitle: product.title || 'Contenido',
        isModalVisible: true
      });
    }
  }

  handleCloseModal = () => {
    this.setState({
      isModalVisible: false,
      currentIframe: '',
      modalTitle: ''
    });
  }

  getUserInformation(user) {
    //console.log("ALL USER INFO CALLED");
    var _this = this;
    database
      .collection("users")
      .where("email", "==", user.email)
      .get()
      .then(function(querySnapshot) {
        //console.log("ID: " + _this.state.urlId);
        querySnapshot.forEach(function(doc) {
          _this.setState({ user: doc.data() });
          doc.ref
            .collection("accesed_series")
            .where("series_id", "==", _this.state.urlId)
            .get()
            .then(function(snapshot) {
              var refArray = [];
              snapshot.forEach(function(series) {
                refArray.push(series.data());
              });
              //console.log(refArray);
              if (refArray.length == 0) {
                //console.log("NO ACCESS TO THIS BOOK");
              } else {
                database
                  .doc("series/" + _this.state.urlId)
                  .get()
                  .then(function(doc) {
                    if (doc.exists) {
                      var series = doc.data();
                      //console.log(series);
                      _this.setState({ series: series });
                        database
                          .collection("books")
                          .where("series","==",doc.id)
                          .get()
                          .then(function(snapshot) {
                            //console.log("BOOKS")
                            var arr = snapshot.docs.sort(_this.sortBooks);
                            //console.log(snapshot.docs[0].data())
                              _this.setState({ books: arr });
                              
                            
                          });
                    } else {
                      //console.log("Series does not exist");
                    }
                  });
              }
            });
        });
      })
      .catch(function(error) {
        //console.log("Error gettin0g document:", error);
      });
  }

  componentDidMount() {
    const { urlId } = this.props.match.params;
    var _this = this;

    this.setState({ urlId: urlId });
    this.unsubscribeFromAuth = auth.onAuthStateChanged(user => {
      if (user) {
        _this.getUserInformation(user);
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribeFromAuth) {
      this.unsubscribeFromAuth();
    }
  }

  render() {
    return ( 
      <div>
				<Row>
					<Col key="ss" xl={16} lg={16} md={16} sm={24} xs={24}>
						<Card className={`gx-card-metrics`}>
							<h1 className="gx-product-title">{this.state.series.sponsor}</h1>
							<h4>{this.state.series.books_description}</h4>
							<p>{this.state.series.sponsor_message}</p>
							<p>{this.state.series.disclamer}</p>
						</Card>
					</Col>
					<Col key="1a" xl={8} lg={8} md={8} sm={24} xs={24}>
						<Card className={`gx-card-metrics`}>
							<img src={this.state.series.sponsor_logo} />
						</Card>
					</Col>
     
     
        {this.state.books.map((book) => (
          <Col key={book.id} xl={6} md={8} sm={24} xs={24}>
            <ProductItem grid product={book.data()} click={this.handleProductClick} />
          </Col>
        ))}
      </Row>
      <Modal
        className="embed-modal"
        title={this.state.modalTitle}
        visible={this.state.isModalVisible}
        onCancel={this.handleCloseModal}
        maskClosable={false}
        keyboard={false}
        closable={true}
        footer={null}
        width={980}
        style={{ paddingBottom: 0 }}
        bodyStyle={{ padding: 0, overflow: 'hidden' }}
        centered
        destroyOnClose
      >
        {this.state.currentIframe && (
          <ResponsiveEmbed
            key={this.state.currentIframe}
            src={this.state.currentIframe}
            title={this.state.modalTitle}
          />
        )}
      </Modal>
      </div>
    );
  }
}

export default BookGrid;
